import { render, staticRenderFns } from "./ForwardManage.vue?vue&type=template&id=25db6bfa&"
import script from "./ForwardManage.vue?vue&type=script&lang=js&"
export * from "./ForwardManage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports